import { render, staticRenderFns } from "./changeAvatar.vue?vue&type=template&id=1d9a0532&scoped=true&"
import script from "./changeAvatar.vue?vue&type=script&lang=ts&"
export * from "./changeAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./changeAvatar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./changeAvatar.vue?vue&type=style&index=1&id=1d9a0532&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a0532",
  null
  
)

export default component.exports